export class LegacyImageFormat {
  id?: number;
  code?: string;
  description?: string;
  width?: number;
  height?: number;
  active?: boolean;
  ord?: number;
  updateDate?: Date;

  constructor(init?: Partial<LegacyImageFormat>) {
    Object.assign(this, init);
  }
}
